import React, { useState } from "react";
import "../style.scss";
import logo from "../img/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useEffect, useRef } from "react";
import { getDatabase, ref, set } from "firebase/database";
import { db } from "../firebase/firebase";
import { addDoc, collection } from "firebase/firestore";
import Typical from "react-typical";
import TypicalText from "./typicalText";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Header() {
  const { t, i18n } = useTranslation();
  // const languages = [ { code: "de", name: "German"}, {code: "en", name: "English"}];
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  // Simpler animation approach
  const [isVisible, setIsVisible] = useState(true);

  const hide = () => {
    console.log("Hiding animation");
    setIsVisible(false);
  };

  const open = () => {
    console.log("Showing animation");
    setIsVisible(true);
  };

  // Make the scroll listener depend on isVisible state
  useEffect(() => {
    const scrollHandler = () => {
      let heightToHideFrom = 200;
      const winScroll =
        document.body.scrollTop || document.documentElement.scrollTop;

      if (winScroll > heightToHideFrom && isVisible) {
        console.log("Hiding animation");
        setIsVisible(false);
      } else if (winScroll <= heightToHideFrom && !isVisible) {
        console.log("Showing animation");
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, [isVisible]);

  // Remove separate function as we're now using inline function in useEffect

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const TypingAnimation = React.memo(() => {
    const [displayText, setDisplayText] = React.useState("");
    const fullText = "# L E T Y O U R B U S I N E S S I D E A S F L Y";
    const subtitleText = "- Busisness Creator and Elevator";
    const subtitleText2 = "- Developing Ideas and Businesses";
    const subtitleText3 = "- Consulting and Investment";
    const [showCursor, setShowCursor] = React.useState(false);
    const [showSubtitle1, setShowSubtitle1] = React.useState(false);
    const [showSubtitle2, setShowSubtitle2] = React.useState(false);
    const [showSubtitle3, setShowSubtitle3] = React.useState(false);
    const intervalRef = React.useRef(null);
    const subtitleTimeoutRef = React.useRef([]);
    const hasAnimatedRef = React.useRef(false);
    const isTypingComplete = displayText.length === fullText.length;
    const hasMountedRef = React.useRef(false); // Track if component has mounted

    React.useEffect(() => {
      // Check if we've already completed the animation in this session
      const hasAnimated = sessionStorage.getItem("typingAnimationCompleted");

      if (hasAnimated) {
        // If already animated, show everything immediately but still set up cursor blink
        setDisplayText(fullText);
        setShowCursor(true);
        setShowSubtitle1(true);
        setShowSubtitle2(true);
        setShowSubtitle3(true);

        // Set up cursor blink
        intervalRef.current = window.setInterval(() => {
          setShowCursor((prev) => !prev);
        }, 500);

        // Clean up interval on unmount
        return () => {
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
          }
        };
      }

      // Reset states for animation
      setDisplayText("");
      setShowSubtitle1(false);
      setShowSubtitle2(false);
      setShowSubtitle3(false);
      setShowCursor(false);

      // Clear any existing intervals
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      // Animation sequence
      let currentIndex = 0;
      const typingSpeed = 50; // Adjust typing speed (ms per character)
      let timeoutId;

      const typeNextCharacter = () => {
        if (currentIndex < fullText.length) {
          setDisplayText(fullText.substring(0, currentIndex + 1));
          currentIndex++;
          timeoutId = setTimeout(typeNextCharacter, typingSpeed);
        } else {
          // Mark animation as completed in session storage
          sessionStorage.setItem("typingAnimationCompleted", "true");

          // Start cursor blink after typing is complete
          setShowCursor(true);
          intervalRef.current = window.setInterval(() => {
            setShowCursor((prev) => !prev);
          }, 500);

          // Animate subtitles in sequence
          const t1 = setTimeout(() => setShowSubtitle1(true), 300);
          const t2 = setTimeout(() => setShowSubtitle2(true), 1200);
          const t3 = setTimeout(() => setShowSubtitle3(true), 2100);
          subtitleTimeoutRef.current = [t1, t2, t3];
        }
      };

      // Start typing after a short delay
      const startTimeout = setTimeout(() => {
        typeNextCharacter();
      }, 500);

      // Cleanup function
      return () => {
        if (timeoutId) window.clearTimeout(timeoutId);
        if (intervalRef.current) window.clearInterval(intervalRef.current);
        window.clearTimeout(startTimeout);
        if (subtitleTimeoutRef.current) {
          subtitleTimeoutRef.current.forEach(clearTimeout);
        }
      };
    }, [fullText]);

    return (
      <div style={{ overflow: "hidden" }}>
        <div style={{ height: 5 }}></div>
        <div
          style={{
            fontSize:
              windowDimensions.width * 0.035 > 30
                ? 30
                : windowDimensions.width * 0.035,
            whiteSpace: "nowrap",
            display: "inline-block",
            position: "relative",
            minWidth: "100%",
          }}
        >
          {displayText}
          <span
            style={{
              opacity:
                showCursor && displayText.length === fullText.length ? 1 : 0,
              transition: "opacity 0.3s ease-in-out",
              marginLeft: "2px",
            }}
          >
            |
          </span>
        </div>
        <div style={{ height: 15 }}></div>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <span
            style={{
              fontSize: 15,
              fontWeight: "normal",
              color: "#fff",
              opacity: showSubtitle1 ? 1 : 0,
              transition:
                "opacity 0.5s ease-in-out, transform 0.5s ease-in-out",
              transform: showSubtitle1 ? "translateY(0)" : "translateY(10px)",
              marginRight: "5px",
            }}
          >
            {subtitleText}
          </span>
          <span
            style={{
              fontSize: 15,
              fontWeight: "normal",
              color: "#fff",
              opacity: showSubtitle2 ? 1 : 0,
              transition:
                "opacity 0.5s ease-in-out, transform 0.5s ease-in-out",
              transform: showSubtitle2 ? "translateY(0)" : "translateY(10px)",
              marginRight: "5px",
            }}
          >
            {subtitleText2}
          </span>
          <span
            style={{
              fontSize: 15,
              fontWeight: "normal",
              color: "#fff",
              opacity: showSubtitle3 ? 1 : 0,
              transition:
                "opacity 0.5s ease-in-out, transform 0.5s ease-in-out",
              transform: showSubtitle3 ? "translateY(0)" : "translateY(10px)",
            }}
          >
            {subtitleText3 + ""}
          </span>
        </div>
      </div>
    );
  }); // this line prevent re rendering

  useEffect(() => {
    console.log("loaded");

    const openIcon = document.querySelector(".fa-bars");
    const closeIcon = document.querySelector(".close-nav");
    const mobileBG = document.querySelector(".mobile-bg");
    const mobileNav = document.querySelector(".mobile-nav");
    const navItem = document.querySelector(".nav-item");
    const navItem2 = document.querySelector(".nav-item2");
    const navItem3 = document.querySelector(".nav-item3");
    const navItem4 = document.querySelector(".nav-item4");
    const navItem5 = document.querySelector(".nav-item5");
    const navItemde = document.querySelector(".nav-item-de");
    const navItemen = document.querySelector(".nav-item-en");
    
    openIcon.addEventListener("click", () => {
      toggleMobileMenu();
      mobileBG.classList.toggle("display-none");
      mobileNav.classList.remove("slide-out");
      mobileNav.classList.toggle("slide-in");
    });

    closeIcon.addEventListener("click", () => {
      mobileBG.classList.toggle("display-none");
      toggleMobileMenu();
      mobileNav.classList.remove("slide-in");
      mobileNav.classList.toggle("slide-out");
    });

    navItem.addEventListener("click", () => {
      mobileBG.classList.toggle("display-none");
      mobileNav.classList.remove("slide-out");
      mobileNav.classList.toggle("slide-in");
      // openIcon.classList.toggle("display-none");
    });

    navItem2.addEventListener("click", () => {
      mobileBG.classList.toggle("display-none");
      mobileNav.classList.remove("slide-out");
      mobileNav.classList.toggle("slide-in");
      // openIcon.classList.toggle("display-none");
    });

    navItem3.addEventListener("click", () => {
      mobileBG.classList.toggle("display-none");
      mobileNav.classList.remove("slide-out");
      mobileNav.classList.toggle("slide-in");
      // openIcon.classList.toggle("display-none");
    });

    navItem4.addEventListener("click", () => {
      mobileBG.classList.toggle("display-none");
      mobileNav.classList.remove("slide-out");
      mobileNav.classList.toggle("slide-in");
      // openIcon.classList.toggle("display-none");
    });

    navItem5.addEventListener("click", () => {
      mobileBG.classList.toggle("display-none");
      mobileNav.classList.remove("slide-out");
      mobileNav.classList.toggle("slide-in");
      // openIcon.classList.toggle("display-none");
      closeMobileMenu();
    });

    navItemde.addEventListener("click", () => {
      mobileBG.classList.toggle("display-none");
      mobileNav.classList.remove("slide-out");
      mobileNav.classList.toggle("slide-in");
      // openIcon.classList.toggle("display-none");
      closeMobileMenu();
    });

    navItemen.addEventListener("click", () => {
      mobileBG.classList.toggle("display-none");
      mobileNav.classList.remove("slide-out");
      mobileNav.classList.toggle("slide-in");
      // openIcon.classList.toggle("display-none");
      closeMobileMenu();
    });

    const contactForm = document.querySelector(".contact-form");
    const fullName = document.querySelector(".full-name");
    const emailAddress = document.querySelector(".email-address");
    const subject = document.querySelector(".subject");
    const message = document.querySelector(".message");
    const submit = document.querySelector(".submit-form");
    const modal = document.querySelector(".modal-wrap");
    const close = document.querySelector(".modal-close");

    close.addEventListener("click", () => {
      modal.classList.toggle("display-none");
    });

    const login = document.querySelector(".btn-login");
    const login2 = document.querySelector(".btn-login2");
    const loginModal = document.querySelector(".login-modal-wrap");

    login.addEventListener("click", () => {
      loginModal.classList.toggle("display-none");
    });

    login2.addEventListener("click", () => {
      loginModal.classList.toggle("display-none");
    });
  }, []);

  return (
    <header style={{ backgroundColor: "#191919" }}>
      <div
        className={`mobile-bg ${isMobileMenuOpen ? "active" : "display-none"}`}
      >
        <ul className="mobile-nav">
          <li>
            <a
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              href="#"
              className="nav-item"
            >
              Start
            </a>
          </li>
          <li>
            <a href="#portfolio" className="nav-item2 btn-login">
              Portfolio
            </a>
          </li>
          <li>
            <a href="#service" className="nav-item3">
              Services
            </a>
          </li>
          {/* <li>
            <a href="#forum" className="nav-item4">
              Forum
            </a>
          </li> */}
          <li>
            <a href="#kontakt" className="nav-item4">
              {t("contact")}
            </a>
          </li>
          <li>
            <a className="nav-item5" href="#öffnungszeiten">
              {t("open")}
            </a>
          </li>
          <li>
            <Link to="/shop">Marketplace</Link>
          </li>
          <li style={{ marginTop: "30px" }}>
            <ul style={{ paddingLeft: "0px" }}>
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "15px",
                }}
              >
                <div
                  style={{
                    width: 25,
                    height: 25,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundImage: `url("https://www.countryflags.com/wp-content/uploads/germany-flag-png-large.png")`,
                    marginRight: "10px",
                  }}
                />
                <a
                  onClick={() => {
                    i18n.changeLanguage("de");
                    localStorage.setItem("language", "de");
                    window.location.reload();
                  }}
                  className="nav-item-de"
                  href="#"
                  style={{
                    color: "#fff",
                    textDecoration: "none",
                    fontSize: "16px",
                    cursor: "pointer"
                  }}
                >
                  {t("germ")}
                </a>
              </li>
              <li style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    width: 25,
                    height: 25,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundImage: `url("https://www.countryflags.com/wp-content/uploads/united-states-of-america-flag-png-large.png")`,
                    marginRight: "10px",
                  }}
                />
                <a
                  onClick={() => {
                    i18n.changeLanguage("en");
                    localStorage.setItem("language", "en");
                    window.location.reload();
                  }}
                  className="nav-item-en"
                  href="#"
                  style={{
                    color: "#fff",
                    textDecoration: "none",
                    fontSize: "16px",
                    cursor: "pointer",
                    marginBottom: "10px",
                  }}
                >
                  {t("eng")}
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <div
          style={{
            backgroundColor: "transparent",
            width: "100%",
            height: "100%",
          }}
          className="close-nav"
        ></div>
      </div>

      <nav
        style={{ backgroundColor: "#191919", maxWidth: "none" }}
        className="container"
      >
        <div style={{ paddingLeft: 15 }}>
          <a
            style={{
              color: "#a4ffee",
              fontSize:
                windowDimensions.width * 0.05 < 28
                  ? windowDimensions.width * 0.05
                  : 28,
              fontWeight: "bold",
            }}
            href=""
          >
            {"I 2 G - I N N O V A T I O N 2 G O"}
            <sup style={{ fontSize: 17, paddingLeft: 2 }}>©</sup>
            <div
              className="animation-container"
              style={{
                transition: "all 0.5s ease-in-out",
                opacity: isVisible ? 1 : 0,
                maxHeight: isVisible ? "300px" : "0px",
                overflow: "hidden",
              }}
            >
              <div style={{ height: 5 }}></div>
              <TypingAnimation />
            </div>
          </a>
        </div>

        <i
          style={{
            paddingRight: "20px",
            color: "#a4ffee",
            paddingLeft: "20px",
          }}
          className="fa-bars"
        >
          <FontAwesomeIcon
            style={{ color: "#a4ffee", cursor: "pointer" }}
            icon={icon({ name: "bars", style: "solid" })}
          />
        </i>
      </nav>
      <div
        style={{
          marginTop: 15,
          width: windowDimensions.width - 30,
          maxWidth: 10000,
          marginLeft:
            (windowDimensions.width - 10000) / 2 > 0
              ? (windowDimensions.width - 10000) / 2
              : 15,
          height: 1,
          backgroundColor: "#fff",
        }}
      ></div>

      <nav
        style={{ backgroundColor: "#191919", maxWidth: "none" }}
        className="container"
      >
        <FontAwesomeIcon
          style={{
            color: "#a4ffee",
            cursor: "pointer",
            paddingLeft: 15,
            fontSize:
              windowDimensions.width * 0.04 < 20
                ? windowDimensions.width * 0.04
                : 20,
          }}
          icon={icon({ name: "phone", style: "solid" })}
        />
        <a
          href="tel:+43 664 1838845"
          style={{
            color: "#a4ffee",
            paddingLeft: 10,
            fontWeight: "normal",
            fontSize:
              windowDimensions.width * 0.03 < 16
                ? windowDimensions.width * 0.03
                : 16,
          }}
        >
          +43 664 1838845
        </a>
        <FontAwesomeIcon
          style={{
            color: "#a4ffee",
            cursor: "pointer",
            paddingLeft: 15,
            fontSize:
              windowDimensions.width * 0.04 < 20
                ? windowDimensions.width * 0.04
                : 20,
          }}
          icon={icon({ name: "envelope", style: "solid" })}
        />
        <a
          href="mailto:office@innovation2go.at"
          style={{
            color: "#a4ffee",
            paddingLeft: 10,
            fontWeight: "normal",
            fontSize:
              windowDimensions.width * 0.03 < 16
                ? windowDimensions.width * 0.03
                : 16,
          }}
        >
          office@innovation2go.at
        </a>
        <ul>
          <li>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              Startt
            </a>
          </li>
          <li>
            <a href="#portfolio" className="btn-login2">
              Portfolio
            </a>
          </li>
          <li>
            <a href="#service">Services</a>
          </li>
          {/* <li>
            <a href="#forum">Forum</a>
          </li> */}
          <li>
            <a href="#kontakt" className="nav-item4">
              {t("contact")}
            </a>
          </li>
          <li>
            <a href="#öffnungszeiten">{t("open")}</a>
          </li>
          <li>
            <Link to="/shop">Marketplace</Link>
          </li>
          <li>
            <div
              style={{ marginRight: 30, marginLeft: 15, flexDirection: "row" }}
              className="lang-menu"
            >
              <a
                style={{
                  width: 17,
                  height: 17,
                  marginRight: 55,
                  backgroundSize: "contain",
                  display: "inline-block",
                  backgroundRepeat: "no-repeat",
                  backgroundImage:
                    t("sellang") == "Deutsch"
                      ? `url("https://www.countryflags.com/wp-content/uploads/germany-flag-png-large.png")`
                      : `url("https://www.countryflags.com/wp-content/uploads/united-states-of-america-flag-png-large.png")`,
                }}
              >
                <div style={{ marginLeft: 25 }} className="selected-lang">
                  {t("sellang")}
                </div>
              </a>
              <ul>
                <li>
                  <a
                    onClick={() => {
                      i18n.changeLanguage("de");
                      localStorage.setItem("language", "de");
                    }}
                    style={{ marginBottom: 5 }}
                    href=""
                    className="de"
                  >
                    {t("germ")}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      i18n.changeLanguage("en");
                      localStorage.setItem("language", "en");
                    }}
                    href=""
                    className="en"
                  >
                    {t("eng")}
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </nav>
    </header>
  );
}
